import axios from 'axios';

import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import { mapResponseErrorToMessage } from '@hotjar/webapp/domains/common/api';

const API_ROOT = '/api/v1/accounts/';

interface TransferOrganization {
  accountId: number;
  userId: number;
  password: string;
  organizationId: number;
}

export async function transferOrganization({
  accountId,
  userId,
  password,
  organizationId,
}: TransferOrganization): Promise<ApiBaseResponse> {
  const response = await axios.post<ApiBaseResponse>(`${API_ROOT}${accountId}`, {
    action: 'transfer_organization_ownership',
    password,
    user_id: userId,
    organization_id: organizationId,
  });

  if (!response.data.success) {
    throw new Error(mapResponseErrorToMessage(response.data.error));
  }

  return response.data;
}
